
    import { computed, ref, PropType, defineComponent, watch  } from "vue";
    import { LineChart } from "vue-chart-3";
    import { Chart, ChartData, ChartOptions, ScatterDataPoint, registerables } from "chart.js";
    import 'chartjs-adapter-date-fns';
    import zoomPlugin from 'chartjs-plugin-zoom';
    import { JednaStanice } from '../mojetypy';

    Chart.register(zoomPlugin);
    Chart.register(...registerables);

    
    var gxMinNactenoPozadavekMs: number = 0;
    var gxMaxNactenoPozadavekMs: number = 0;
    var gbProbihaNacitani: boolean = false;

    
   
    //export default {
    export default defineComponent({

        name: "CoralGraph",
        components: { LineChart },

        props: {
            propVybranaStanice: Object as PropType<JednaStanice>
        },
      

        setup( props ) {

            const bGrafVidet = ref(true);       // přepíníní pohledu mezi Graf/Tabulka
            const msg = ref('');                // chybové hlášky
            const lineRef = ref();              // Graf komponenta sem dá referenci na vnitřní graf
            const flagloaded = ref(false);      // až když se nastaví na true, graf bude zobrazen  v-if="flagloaded"

            // pole dat jednotlivých křivek
            // když se do nějaké křivky napíšou data, hned se to v grafu změní
            //const reactivePoleDataVsechKrivek = reactive(new Array<Array<ScatterDataPoint>>());

            const reactivePoleDataVsechKrivek = ref(new Array<Array<ScatterDataPoint>>());

            // event, když se změní vybraná stanice
            watch(
                () => props.propVybranaStanice,
                (stanice) => {
                    console.log("Graph:event propVybranaStanice: " + (stanice as JednaStanice).jmeno);
                    pocatecniNacteni();
                }
            );


            /*
            // aktuálně vybraná křivka, reaktivně se zapsalo do propVybranaStanice
            // tedy se i zavolá tato
            // potřebuje ho i Tabulka, když dělá řádky a sloupce
            const arrAttribKrivek = computed<AtributyKrivky[]>(() => {
                console.log("UPDATE AtributyKrivky computed");

                if (props.propVybranaStanice == null) {
                    //var arrAttribKrivek: AtributyKrivky[] = [];
                    return []; //arrAttribKrivek;
                }
                
                return props.propVybranaStanice?.graph;
            });
           */



         

            // srovnaná data pro Tabulku
            // klíč:[čas]       pole[idxSignalu]  ( hodnoty všech signálů, když tam není tak NaN )
            //
            const arrTable = computed(() => {
                const mapUnsorted = new Map<number, number[]>();

                console.log("UPDATE arrTable computed");


                // ještě není správná hodnota
                if (lineRef.value != null) {
                    var dtStart = lineRef.value.chartInstance.scales['x'].min;
                    var dtEnd = lineRef.value.chartInstance.scales['x'].max;

                    var pocetSignalu = reactivePoleDataVsechKrivek.value.length;

                    // console.log("UPDATE arrTable computed Pocet: " + pocetSignalu + "  " + dtStart + " " + dtEnd);

                    reactivePoleDataVsechKrivek.value.forEach((krivka, idxSignalu) => {

                        console.log("UPDATE arrTable computed forEach idxSignalu: " + idxSignalu);

                        krivka.forEach(bod => {
                            // brát jen body co jsou zobrazeny v Grafu
                            if (bod.x >= dtStart && bod.x <= dtEnd) {
                                // ještě tam čas není
                                if (!mapUnsorted.has(bod.x)) {
                                    mapUnsorted.set(bod.x, new Array<number>(pocetSignalu));     // přidá nové pole pro všechny signály
                                }
                                // map[klíč_čas] poleSignálů
                                mapUnsorted.get(bod.x)![idxSignalu] = bod.y;
                            }
                        });
                    });
                }
                else
                    console.log("UPDATE arrTable computed EMPTY");

                /////////////////////////////////
                // map sort
                var keys: number[] = [];
                var sortedMap = new Map();

                // Put keys in Array
                mapUnsorted.forEach(function callback(value, key) {
                    keys.push(key);
                });

                keys.sort().forEach(klic => {
                    sortedMap.set(klic, mapUnsorted.get(klic));
                });

              
                return sortedMap;
            });


            // OSY
            // volá se jen při prvotním otevření Grafu, když flagloaded nastavím na true
            const options = computed<ChartOptions<"line">>(() => {

                console.log("UPDATE options computed");

                var vys: ChartOptions<"line"> = {
                    responsive: true,
                    maintainAspectRatio: false,

                    animation: {
                        duration: 0         // animace vypnuta
                    },

                    scales: {
                        x: {
                            type: 'time',

                            time: {
                                //unit: 'minute',       // tohle tam nedávat, pak se to dělá auto
                                displayFormats: {
                                    month: 'dd.MM.yyyy',
                                    day: 'dd.MM',
                                    hour: 'dd.MM HH:mm:ss',
                                    minute: 'mm:ss',
                                    second: 'ss',
                                },
                                tooltipFormat: 'dd.MM.yyyy HH:mm:ss',
                            },

                            display: true,
                            title: {
                                display: true,
                                text: 'datum čas'
                            },
                            ticks: {
                                // source: 'data',      // zobrzuje cas jen pro zadana dato, to nechci

                                major: {
                                    enabled: true
                                },


                                //color: (context) => context.tick && context.tick.major && '#FF0000',
                                color: context => {
                                    if (context.tick && context.tick.major) return '#FF0000';
                                },



                                // interface TickOptions
                                //font: function (context) {
                                //    if (context.tick && context.tick.major) {
                                //        return {
                                //            weight: 'bold',
                                //            family: "",
                                //            size: 12,
                                //            style: 'normal',
                                //            lineHeight: 12
                                //        };
                                //    }
                                //},

                            },
                        },
                    },
                    plugins: {
                        zoom: {
                            zoom: {
                                wheel: {
                                    enabled: true,
                                },
                                drag: {
                                    enabled: true,
                                    modifierKey: 'ctrl',
                                },
                                pinch: {
                                    enabled: true
                                },
                                mode: 'x',
                                onZoom: (context) => mojeOnPanZoom(context.chart.scales['x'].min, context.chart.scales['x'].max)
                            },
                            pan: {
                                enabled: true,
                                mode: 'x',
                                onPan: (context) => mojeOnPanZoom(context.chart.scales['x'].min, context.chart.scales['x'].max)        // pozice time dorazu
                            }

                            /* omezí x, že se mimo meze nedá posouvat: {
                                x: { min: dateMinus.getTime(), max: dateNow.getTime() },
                            }
                            */
                        },
                        /*
                        legend: {
                            position: "top",
                        },
                        title: {
                            display: true,
                            text: "nadpis",
                        },

                        tooltip: {
                            callbacks: {

                                label: function (context) {
                                    let label = context.dataset.label || '';

                                    if (label) {
                                        label += 'koko';
                                    }
                                    //if (context.parsed.y !== null) {
                                    //    label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
                                    //}
                                    return "aaa";
                                }
                            }
                        }
                        */
                    },
                };


                // dynamicky přidávat osy y0, y1, ...
                var indexOsy: number = 0;

                props.propVybranaStanice?.graph.forEach((k) => {

                    // stejnaOsa = true/false
                    if (k.stejnaOsa) {
                        return; // vlastně je to continue
                    }

                    var jmenoOsy = "y" + indexOsy;         // "y0"
                    indexOsy++;

                    console.log("UPDATE options computed ... for osy " + jmenoOsy);


                    // ! zruší kontrolu TS na null, scales už jsme tam určitě dali viz nahoře, tohle není nutné  //if (vys.scales != null)
                    // přidat property jména y0
                    vys.scales![jmenoOsy] = {
                        display: true,
                        title: {
                            display: true,
                            text: k.popis
                        },
                        grid: {
                            //color: 'red',             // čárečky u čísla a pokračující linka    //'rgba(255,0,0,0.1)',
                            borderColor: k.color //'red'        // barva osy
                        },
                        ticks: {
                            color: k.color,      // barva čísel na ose
                        },
                        suggestedMin: isNaN(k.suggestedMin) ? undefined : k.suggestedMin,
                        suggestedMax: isNaN(k.suggestedMax) ? undefined : k.suggestedMax,
                    };
                });

                return vys;
            });


          

            // KRIVKY
            // volá se, až když Graf chce ukázat data, tedy po prvním naplnení i následně když se pak někdy změní data křivek
            const krivkyData = computed<ChartData<"line">>(() => {
                console.log("UPDATE krivkyData computed");

                var vys: ChartData<"line"> = {
                    datasets: [],
                };

                // přes všechny zadané křivky v URL
                var pocitadloOs: number = -1;           // první osa musí být y0, tak aby po první ne-k.stejnaOsa to bylo 0

                props.propVybranaStanice?.graph.forEach((k, index) => {

                    // když má křivka stejnou osu, tak ji přiřaď k té minulé ose
                    if (!k.stejnaOsa)
                        pocitadloOs++

                    var jmenoOsy = 'y' + pocitadloOs;

                    vys.datasets.push({
                        label: k.signame,
                        data: reactivePoleDataVsechKrivek.value[index],
                        backgroundColor: k.color,         // i barva výplně bodů
                        pointBorderColor: k.color,
                        borderColor: k.color,
                        pointRadius: 2,

                        fill: false,
                        cubicInterpolationMode: 'default',
                        tension: 0.3,
                        yAxisID: jmenoOsy        // y0
                    })
                });

                return vys;
            });


            // asynchronně se zeptá na data jedné křivky
            async function fetchJednuKrivku(sigName: string, fromTime: number, toTime: number, timeZaokrouhleni: number): Promise<ScatterDataPoint[]> {
                try {
                    console.log("fetchJednuKrivku START " + sigName + " " + fromTime + " " + toTime);

                    // když je v rootu na WebServeru, tak tam je jen ./
                    // když je ale v subServeru, tak to musí být takhle, relativně k TÉHLE aplikaci ( to /TnWeb tam už není )
                    var sUrlPath = (process.env.NODE_ENV == 'production') ? './Backend/' : './';

                    // hook ty number vrací jako desetinná čísla, to pak není long čas a padá to při volání fetch
                    fromTime = Math.trunc(fromTime);
                    toTime = Math.trunc(toTime);


                    //var sUrl = './TnGraphData/hop?sig=' + sigName + '&t0=' + fromTime + '&t1=' + toTime + '&tz=' + timeZaokrouhleni;
                    var sUrl = sUrlPath + 'hop?sig=' + sigName + '&t0=' + fromTime + '&t1=' + toTime + '&tz=' + timeZaokrouhleni;
                    //msg.value = sUrl;

                    //console.log("fetchJednuKrivku " + sUrl);
                    var r = await fetch(sUrl);

                    // console.log("fetch1");
                    var j = await r.json();
                    //console.log("fetch2 " + JSON.stringify(j) );
                    return j; // as KrivkaVsechnyBody;
                }
                catch(err) {
                        if (err) {
                            var txt = "fetchJednuKrivku ERR " + (err as Error).message;
                            console.log(txt);
                            msg.value = txt;
                    }
                    return new Array<ScatterDataPoint>();
                }
            }



            // od zadaného času [gxMinNacteno, gxMaxNacteno] natáhne do paměti
            async function natahniVsechnyKrivky( xMin:number, xMax:number) {

                // data všech křivek vymazat
                // reactivePoleDataVsechKrivek.splice(0, reactivePoleDataVsechKrivek.length);     

                var tmp = new Array<Array<ScatterDataPoint>>();


                //var dt0 = new Date(xMin);
                //var dt1 = new Date(xMin);
                //console.log("natahniVsechnyKrivky time: " + dt0.toUTCString() + " " + dt1.toUTCString());

                if (props.propVybranaStanice != null) {
                    for (var i = 0; i < props.propVybranaStanice?.graph.length; i++) {
                        var k = await fetchJednuKrivku(props.propVybranaStanice?.graph[i].signame, xMin, xMax, props.propVybranaStanice?.graph[i].zaookrouhleniCasu);
                        //reactivePoleDataVsechKrivek[i] = k;
                        tmp[i] = k;
                        console.log("konec Fetch krivky OK " + props.propVybranaStanice?.graph[i].signame + " " + xMin + " " + xMax);
                    }

                    reactivePoleDataVsechKrivek.value = tmp;
                }
            }

            function pocatecniNacteni() {
                flagloaded.value = false;           // aby se pak na grafu opět zavolalo přenačtení os (options computed)

                // natáhnout data a následně reaktivně vše vytvořit
                var dateNow = new Date();

                var xMax = dateNow.getTime();
                var xMin = xMax - 1000 * 3600 * 24;    // 1 den zpět


                natahniVsechnyKrivky(xMin, xMax).then(() => {
                    flagloaded.value = true;
                });
            }



            // volá se, když Graf dělá PANE nebo ZOOM
            function mojeOnPanZoom(casStartPozadavek: number, casStopPozadavek: number) {

                // hook ty number vrací jako desetinná čísla, to pak není long čas a padá to při volání fetch
                casStartPozadavek = Math.trunc(casStartPozadavek);
                casStopPozadavek = Math.trunc(casStopPozadavek);

                if (gbProbihaNacitani) {
                    gxMinNactenoPozadavekMs = casStartPozadavek;
                    gxMaxNactenoPozadavekMs = casStopPozadavek;
                    console.log("ULOZEN Pozadavek na dalsi nacteni " + gxMinNactenoPozadavekMs + " " + gxMaxNactenoPozadavekMs);
                }
                else {
                    gbProbihaNacitani = true;
                    natahniVsechnyKrivky(casStartPozadavek, casStopPozadavek).then(() => {

                        // načtení skončilo
                        gbProbihaNacitani = false;

                        // během načítání vznikly další posuny a je potřeba znovu načíst
                        if (gxMinNactenoPozadavekMs != 0 || gxMaxNactenoPozadavekMs != 0) {

                            var xMin = gxMinNactenoPozadavekMs;
                            var xMax = gxMaxNactenoPozadavekMs;
                            gxMinNactenoPozadavekMs = 0;
                            gxMaxNactenoPozadavekMs = 0;
                            console.log("Pozadavek na dalsi nacteni behem nacitani " + " " + xMin + " " + xMax);

                            mojeOnPanZoom(xMin, xMax);
                        }
                    });
                }
            }


            // lineRef.value.chartInstance.resetZoom();
            // lineRef.value.chartInstance.update('none');

            // zoom out
            // 0.9  přidá 1/10      10%
            // 0.5  přidá 1/2       50%
            // 0.25 přidá 2/3
            // 0.1                 100%, neboli 2x se to změnší, ale míň nejde, asi nějaký limit
            function zoomOut() {
                lineRef.value.chartInstance.zoom(0.1);
            }

            // zoom in
            // Zvětšení N krát  zoom = 1 + (N-1)/N      2x  1.5,  4x 1.75   8x  1+7/8
            //
            function zoomIn() {
                lineRef.value.chartInstance.zoom(1.1);
            }

            function zoomReset() {
                pocatecniNacteni();
                lineRef.value.chartInstance.resetZoom();
            }


         


            /*
          function zoomDen( chart : typeof LineChart) {

              var dateNow = new Date();
              var dateMinus = new Date(dateNow.getTime() - 1 * 1000 * 3600 * 24);     // 3 dny zpět
              //lineRef.value.chartInstance.zoomScale('x', { min: dateMinus.getTime(), max: dateNow.getTime() }, 'default');
              chart.zoomScale('x', { min: dateMinus.getTime(), max: dateNow.getTime() }, 'default');


              //// nazoomovat na poslední den, když jsou načteny 3 dny
              //var kolikNacteno = 3;

              //// posunout vlevo o velikost 1/3
              //var a = lineRef.value.chartInstance.chartArea;
              //console.log("area: " + a.left + " " + a.right);
              //var posun = (a.right - a.left) / kolikNacteno;
              //lineRef.value.chartInstance.pan(-posun);

              //// zommovat 3x   1 + (N-1)/N
              //lineRef.value.chartInstance.zoom(1 + (kolikNacteno - 1) / kolikNacteno);

          }
          */


            function MujTimeFormat(t: number): string {
                var dt = new Date(t);

                return dt.getDate().toString().padStart(2, "0") + "." +
                    (dt.getMonth() + 1).toString().padStart(2, "0") + "." +
                    dt.getFullYear() + " " +
                    dt.getHours().toString().padStart(2, "0") + ":" +
                    dt.getMinutes().toString().padStart(2, "0") + ":" +
                    dt.getSeconds().toString().padStart(2, "0");
            }



            return {
                krivkyData,
                lineRef,
                options,
                flagloaded,
                zoomOut,
                zoomIn,
                zoomReset,
                //handleChartRender,
                //arrAttribKrivek,
                arrTable,
                MujTimeFormat,
                bGrafVidet,
                msg,
            };
        },
    });


    /* zajímavé  funkce sleep
           const DEF_DELAY = 1000;
           function sleep(ms : number) {
               return new Promise(resolve => setTimeout(resolve, ms || DEF_DELAY));
           }
               //sleep(10).then(() => {
               //    zoomDen();
               //});
           */


